import script from "./Accordian.vue?vue&type=script&setup=true&lang=js"
export * from "./Accordian.vue?vue&type=script&setup=true&lang=js"

import "./Accordian.vue?vue&type=style&index=0&id=d854e02e&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d854e02e"]])

export default __exports__